module.exports = __webpack_public_path__ + "static/dir-de9d60704732e589de535cbbd79d0ec5.mp4";